import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { rejectPlan } from "./api";
import { handlePlanDecisionError, invalidatePlanViews } from "./planRefusal";

interface RejectPlanVariables {
  readonly reason?: string;
}

// Отклонение плана задачи (AWAITING_PLAN_APPROVAL → DRAFT).
// На успех и на 409 `not_awaiting_plan_approval` перечитываем всё, что
// показывает состояние задачи (`invalidatePlanViews`); на 409 — ещё и
// уведомление.
export function useRejectPlan(
  taskId: string,
): ReturnType<typeof useMutation<void, Error, RejectPlanVariables>> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, Error, RejectPlanVariables>({
    mutationFn: ({ reason }) => rejectPlan(taskId, reason),
    onSuccess: () => {
      invalidatePlanViews(queryClient, taskId);
    },
    // Проигрыш гонки (план уже не ждёт решения): перечитывание и
    // уведомление — в `handlePlanDecisionError`.
    onError: (error) => {
      handlePlanDecisionError(queryClient, taskId, error, t);
    },
  });
}
